import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  onClick,
  className = '',
  fullWidth = false
}: ButtonProps) {
  return <motion.a href="#" onClick={e => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  }} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center
        bg-cta hover:bg-cta-hover text-white 
        font-bold text-lg md:text-xl py-4 px-8 
        rounded-full shadow-lg transition-colors
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-17">
      {children}
    </motion.a>;
}